import React from 'react';

import { CustomText } from '@components/shared/common';
import { formatDateAndTime } from '@utils/common';

interface TimeDurationProps {
  date: string;
  time: string;
  duration: number;
}

const TimeDuration: React.FunctionComponent<TimeDurationProps> = ({
  date,
  time,
  duration,
}) => (
  <>
    <CustomText
      color="#737373"
      fSize="22px"
      fWeight="300"
      lHeight="27px"
      lSpacing="0.34px"
      mfSize="18px"
      mfWeight="300"
      mColor="#737373"
      pr="5px"
    >
      {formatDateAndTime(date, time)}
    </CustomText>
    &nbsp;
    <span color="#737373">·</span>
    &nbsp;
    <CustomText
      color="#737373"
      fSize="22px"
      fWeight="300"
      lHeight="27px"
      lSpacing="0.34px"
      mfSize="18px"
      mfWeight="300"
      mColor="#737373"
      pl="5px"
    >
      {duration} min
    </CustomText>
  </>
);

export default TimeDuration;
